<script setup>
import { onMounted, computed } from 'vue';
import Algolia from './components/Algolia.vue';

const { content, locale, algoliaCreds } = window.appData;

const searchGarminText = computed(() => content?.references?.[0]?.fields?.placeholderText);

onMounted(() => {
  const searchButton = document.getElementById('js__search-button');
  if (searchButton) {
    searchButton.style.display = 'none';
  }
});
</script>

<template>
  <div>
    <g-global-styles />
    <g-heading class="visually-hidden">
      <h1>{{ searchGarminText }}</h1>
    </g-heading>
    <Algolia
      v-if="content.displayType === 'Search'"
      :content="content"
      :locale="locale"
      :algolia-creds="algoliaCreds"
    />
  </div>
</template>

<style lang="scss">
  .visually-hidden {
    @include visually-hidden();
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {

    p {
      margin: 0;
    }
  }
</style>
